import React from 'react';
import {ASK_LIO_KNOWLEDGE_BASE} from '../../constants/constants';
import styles from './style.module.scss';
import {Box, Typography} from '@mui/material';
import {downloadDocument} from '../../api/AskLioService';
import {useToast} from '../../contexts/toastContext/ToastContext';
import {t} from 'i18next';
type AskLioResponseProps = {
  text: string;
  className?: string;
};

const AurAskLioResponse: React.FC<AskLioResponseProps> = ({
  text = '',
  className = '',
}) => {
  const {showToast} = useToast();
  const handleDownloadClick = async (
    e: React.MouseEvent<HTMLAnchorElement>,
    fileName: string,
    knowledgeBase: string
  ) => {
    try {
      e.preventDefault();
      const response = await downloadDocument(knowledgeBase, fileName);
      const downloadUrl = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = downloadUrl;
      link.download = fileName;
      link.click();

      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      showToast(t('askLio.documentDownloadFailed'), 'error');
    }
  };

  const preprocessText = (text: string) => {
    const idRegex = /\b[a-zA-Z0-9./-]+\.(pdf|doc|docx|txt)\b/g; // Match valid filenames
    const elements: React.ReactNode[] = [];
    let lastIndex = 0;

    // Process the text by replacing matches with JSX elements
    text.replace(idRegex, (match, _, offset) => {
      // Add text before the match
      if (offset > lastIndex) {
        const part = text.slice(lastIndex, offset);
        elements.push(
          <span
            key={`text-${lastIndex}`}
            dangerouslySetInnerHTML={{
              __html: part
                .replace(/\n/g, '<br>') // Replace new lines
                .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'), // Replace tabs
            }}
          />
        );
      }

      // Add the matched filename as a clickable link
      elements.push(
        <a
          href="#"
          key={`link-${offset}`}
          onClick={(e) => handleDownloadClick(e, match, ASK_LIO_KNOWLEDGE_BASE)}
          className={styles.downloadLink}
        >
          {match}
        </a>
      );

      // Update lastIndex to after the current match
      lastIndex = offset + match.length;

      return match; // Necessary for replace to function
    });

    // Add any remaining text after the last match
    if (lastIndex < text.length) {
      const remaining = text.slice(lastIndex);
      elements.push(
        <span
          key={`text-${lastIndex}`}
          dangerouslySetInnerHTML={{
            __html: remaining
              .replace(/\n/g, '<br>')
              .replace(/\t/g, '&nbsp;&nbsp;&nbsp;&nbsp;'),
          }}
        />
      );
    }

    return elements;
  };

  return (
    <>
      <Box className={`${styles.aurBoxStart}`}>
        <Box className={`${className} ${styles.aurBoxResponse}`}>
          <Typography className={`${styles.aurBoxResponseTypography}`}>
            {preprocessText(text)}
          </Typography>
        </Box>
      </Box>
    </>
  );
};

export default AurAskLioResponse;
